import { count_THANKS_VOTES, SAY_THANK_YOU } from 'mk/autogenerated/translations/ExperienceFooter.3c866d8b8823f8361837dfb033130fda'
import { ExperienceEntity } from 'mk2/apps/wiki/schemas';
import Like, { LikeType } from 'mk2/containers/Like/Like';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import styles from './ExperienceFooter.mscss';

interface OwnProps {
    experience: ExperienceEntity;
}

type Props = OwnProps;

export default class ExperienceFooter extends React.Component<Props> {

    public render() {
        const {experience} = this.props;

        return (
            <div className={styles.ExperienceFooter}>
                <div className={styles.ExperienceFooter__likesCount}>
                    {interpolate(count_THANKS_VOTES, {count: experience.likeable.likesCount})}
                </div>
                <Like
                    id={experience.id}
                    entity="wiki-experience"
                    type={LikeType.IconLabel}
                    label={SAY_THANK_YOU}
                />
            </div>
        );
    }
}
